<template>
  <div class="welcome">
    <section class="section is-fullheight">

        <div class="container">
            <!-- Welcome -->
            <div class="welcome__step container" v-if="step == 1">
                <h4 class="title page-title has-text-centered has-padding-v-50 is-4 is-marginless">Welcome to the Marketplace {{ supplier.company ? supplier.company.title : '' }}</h4>
                <div class="columns">
                  <div class="column is-full welcome__feed">
                    <p>You are a registered supplier of BestAgent Marketplace.</p>

                    <p>On this welcome page you will be kept up to date with the latest news in the Marketplace.</p>

                    <p>As an approved supplier, you have the option to activate your subscription to the Marketplace and then connect your product so you can start selling your product or service through the Marketplace.</p>

                    <p>If you have any questions, please visit our <a href="#" @click.prevent="$router.push('/faqs')" class="has-text-weight-bold">FAQ's</a> or email <a href="mailto:hello@bestagent.ltd" class="has-text-weight-bold">hello@bestagent.ltd</a>.</p>
                  </div>
                </div>
                <div class="columns">
                    <div class="column is-two-thirds welcome__feed">
                        <div class="welcome__feed-wrapper">
                            <div class="has-padding-bottom-50">
                                <h4 class="is-uppercase">BestAgent Blog</h4>
                            </div>

                            <div class="columns">
                                <div class="column welcome__feed__post has-padding-bottom-30 is-half">
                                    <div class="welcome__feed__post-title"><a class="has-margin-v-10" target="_blank" href="https://bestagent.co.uk/proptech-is-failing-to-help-an-industry-it-doesnt-understand/"><h4 class="">PropTech is failing to help an industry it doesn’t understand. Agents can change that.</h4></a></div>
                                    <div class="welcome__feed__post-img" style="background-image:url('https://bestagent.co.uk/wp-content/uploads/2018/10/WhatsApp-Image-2018-10-02-at-14.20.56.jpeg')"></div>
                                    <a class="button" target="_blank" href="https://bestagent.co.uk/proptech-is-failing-to-help-an-industry-it-doesnt-understand/">Read More</a>
                                </div>
                                <hr>
                                <div class="column welcome__feed__post has-padding-bottom-30 is-half">
                                    <div class="welcome__feed__post-title"><a class="has-margin-v-10" target="_blank" href="https://bestagent.co.uk/the-truth-about-why-nobody-understands-what-estate-agents-really-do/"><h4 class="">The truth about why nobody understands what estate agents really do</h4></a></div>
                                    <div class="welcome__feed__post-img" style="background-image:url('https://bestagent.co.uk/wp-content/uploads/2019/05/32_Steps_Of_Agency_Diagram-1100x765.png')"></div>
                                    <a class="button" target="_blank" href="https://bestagent.co.uk/the-truth-about-why-nobody-understands-what-estate-agents-really-do/">Read More</a>
                                </div>
                                <hr>
                            </div>
                            <div class="columns">
                                <div class="column welcome__feed__post has-padding-bottom-30 is-half">
                                    <div class="welcome__feed__post-title"><a class="has-margin-v-10" target="_blank" href="https://bestagent.co.uk/christopher-watkin-heroes-of-agency-charlie-wright/"><h4 class="">Heroes of Agency, Episode 1: Christopher Watkin</h4></a></div>
                                    <div class="welcome__feed__post-img"><img src="https://bestagent.co.uk/wp-content/uploads/2019/04/heroesofagencylogo-1100x832.png" alt=""></div>
                                    <a class="button" target="_blank" href="https://bestagent.co.uk/christopher-watkin-heroes-of-agency-charlie-wright/">Read More</a>
                                </div>
                            </div>

                            <!-- BLOG FEED -->
                            <!-- <div id="post_feed">

                              <div class="item" v-for="item in posts.items">
                                <div class="thumb" v-thumb="item.featured_media" v-show="item.featured_media"></div>

                                <a :href="item.link" target="_blank" class="title">{{item.title.rendered}}</a> -->
                                <!-- <div class="date">{{item.date | formatDate}}</div> -->
                                <!-- <div class="desc">{{{item.excerpt.rendered | removeMoreLink}}}</div> -->
                              <!-- </div>

                              <button class="more" @click="showMore" v-show="posts.items.length > posts.showed">show more</button>

                            </div> -->

                        </div>
                    </div>
                    <div class="column has-text-centered welcome__subscription">
                        <div class="level" @click.prevent="$router.push('/activate')">
                            <div class="">
                                <p class="subtitle">Activate subscription for £75</p>
                                <p class="is-size-7">NOTE: Your account is not active yet. If you would like to sell your product on the marketplace you will need to pay
                                  £75.00 pcm to be an active supplier.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Step 2 -->
            <div class="start__step container" v-if="step == 2">
                <h5 class="title is-5">Step 2: Please enter the authorised representative of {{ supplier.company ? supplier.company.title : '' }}</h5>

                <div class="start__btn-next">
                    <a class="button is-success btn-next is-small" @click.prevent="step += 1;">Next</a>
                </div>
            </div>

            <b-loading :is-full-page="true" :active="isLoading"></b-loading>
        </div>
    </section>
  </div>
</template>
<script src="libs/vue.min.js"></script>
<script src="libs/vue-resource.min.js"></script>

<script>
import axios from 'axios';
import api from '../libs/api';
import sendEvent from '../libs/sendEvent';

export default {
  name: 'welcome',
  data() {
    return {
      step: 1,
      companyHouseResults: [],
      showCompanyCard: false,
      isLoading: false,
      supplier: {
        company: null,
        commercial: {
          name: '',
          email: '',
          jobTitle: '',
          phone: '',
        },
        technical: {
          name: '',
          email: '',
          jobTitle: '',
          phone: '',
        },
      },
      posts: {
        itemsPerPage: 5,
        items: [],
        showed: this.itemsPerPage
      },
    };
  },
  components: {
  },
  async created() {
    this.supplier = await api({
      endpoint: `${process.env.VUE_APP_API}/suppliers`,
      path: '/info',
      method: 'GET',
    });
    if (this.supplier && this.supplier.active == true) {
      this.$router.push("/");
    }
    this.supplier.company = this.supplier.companyData;

    const posts = await api({endpoint: 'https://bestagent.co.uk/wp-json/wp/v2', path: '/posts', method: 'GET'});

  },
  methods: {
    setCompany(company) {
      if (company && company.hasOwnProperty('title')) {
        this.supplier.company = company;
        this.showCompanyCard = true;
      }
    },
    showMore:function(){
      this.posts.showed+=this.posts.itemsPerPage;
    }
  },
};
</script>
